import { NotificationManager } from 'react-notifications';

/**
 * Refreshes the expedient documents after a save. A failed refresh is reported but not rethrown:
 * the document is already saved, and treating it as a failed save would lead to a duplicate.
 *
 * @param {function(): Promise<void>} refreshDocuments Fetches the documents of the expedient.
 * @returns {Promise<void>}
 */
export const refreshDocumentsSafely = async (refreshDocuments) => {
  try {
    await refreshDocuments();
  } catch (error) {
    console.error(error);
    NotificationManager.error(
      'No se pudo actualizar la lista de documentos del expediente. Recarga la página para verla.'
    );
  }
};
